<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" content-class="loading-dialog">
      <v-container fill-height>
        <v-layout row justify-center align-center>
            <v-flex xs12>
              <v-card elevation="0">
                <v-card-text>
                  <div class="float-right" v-if="isStatus">
                    <span class="font-weight-bold">{{processing}}</span> / <span class="font-weight-bold">{{complete}}</span>
                  </div>
                  <v-progress-linear
                    :color="color"
                    height="10"
                    :value="percent"
                    striped
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'FullScreenProgress',
  props: {
    show: Boolean,
    isStatus: Boolean,
    processing: Number,
    complete: Number,
    color: String
  },
  data() {
    return {
      percent: 0
    };
  },
  watch: {
    processing(value) {
      this.calcPercent(value)
    }
  },
  mounted: function() {
    this.calcPercent(this.processing)
  },
  methods: {
    calcPercent(value) {
      this.percent = Math.round((value / this.complete) * 100, 0)
    }
  }
};
</script>
<style>
.loading-dialog {
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// FullScreenProgress.vue?7f59d030